'use client';
import { useActiveLab } from '@witmetrics/data-store';
import { Tab } from '@/components/TabsBlock';
import Divider from '@/components/Divider';
import TasksSection from './TasksSection';
import ProductsSection from './ProductsSection';
import { classes } from './utils';

export type OverviewTabProps = {
  isFetchingData: boolean;
  name: string;
  label: string;
};

export default function OverviewTab({
  isFetchingData,
  name,
  label,
}: OverviewTabProps) {
  const activeLab = useActiveLab();

  return (
    <Tab className={classes.tab} name={name} label={label}>
      {activeLab && (
        <>
          <TasksSection isFetchingData={isFetchingData} />
          <Divider />
        </>
      )}
      <ProductsSection isFetchingData={isFetchingData} />
    </Tab>
  );
}
